import { render, staticRenderFns } from "./SendLink.vue?vue&type=template&id=0b3b3d5c&scoped=true&"
import script from "./SendLink.vue?vue&type=script&lang=js&"
export * from "./SendLink.vue?vue&type=script&lang=js&"
import style0 from "./SendLink.vue?vue&type=style&index=0&id=0b3b3d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3b3d5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
